// extracted by mini-css-extract-plugin
module.exports = {"message_body":"Index__message_body___1H1bW","loading_image_container":"Index__loading_image_container___3ehPM","loading_image":"Index__loading_image___30Gg_"};